'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'solar-system';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e02f';
var svgPathData = ['M58 58A32 32 0 1 0 103.3 103.3 32 32 0 1 0 58 58zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zM346.5 131.5a24 24 0 1 0 33.9 33.9 24 24 0 1 0 -33.9-33.9zm62.2 277.2A32 32 0 1 0 454 454 32 32 0 1 0 408.7 408.7z', 'M114.6 114.6c-15.7 15.7-39.5 18.2-57.9 7.7-25.7 38.2-40.7 84.2-40.7 133.7 0 132.5 107.5 240 240 240 32.4 0 63.2-6.4 91.4-18 2.6 4.7 5.7 9.2 9.1 13.5-30.9 13.2-64.8 20.5-100.5 20.5-141.4 0-256-114.6-256-256 0-53.4 16.3-103 44.3-144-16.3-18.9-15.5-47.4 2.4-65.3 18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9zM397.4 397.4c15.7-15.7 39.5-18.2 57.9-7.7 25.7-38.2 40.7-84.2 40.7-133.7 0-132.5-107.5-240-240-240-32.4 0-63.2 6.4-91.4 18-2.6-4.7-5.7-9.2-9.1-13.5 30.9-13.2 64.8-20.5 100.5-20.5 141.4 0 256 114.6 256 256 0 53.4-16.3 103-44.3 144 16.3 18.9 15.5 47.4-2.4 65.3-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9zM103.3 103.3A32 32 0 1 0 58 58 32 32 0 1 0 103.3 103.3zM454 454A32 32 0 1 0 408.7 408.7 32 32 0 1 0 454 454zM346.5 131.5a24 24 0 1 0 33.9 33.9 24 24 0 1 0 -33.9-33.9zm-19-.6c-21.1-12.1-45.5-19-71.5-19-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144c0-26-6.9-50.4-19-71.5-14.9 7.3-33.4 4.7-45.8-7.7s-15-30.9-7.7-45.8zm9.9-12.8c15.7-13.6 39.5-12.9 54.4 2s15.6 38.7 2 54.4c14.1 23.8 22.2 51.7 22.2 81.4 0 88.4-71.6 160-160 160S96 344.4 96 256 167.6 96 256 96c29.7 0 57.5 8.1 81.4 22.2zM304 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-112 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSolarSystem = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;